import { Source } from '@atlassian/mpac-types';
export const getAppListingUrl = (source, hostUrl, appKey) => {
  if (source === Source.PRODUCT) {
    return "".concat(hostUrl, "/discover/app/").concat(appKey);
  }
  return "".concat(hostUrl, "/plugins/").concat(appKey);
};